import { getMaterial } from "./database_helpers";
import { defaultEdge } from "./stolarz_form_defaults";
import { DBMaterialType } from "../database_types";
import { SheetData } from "./stolarz_form_types";

export type EdgeSummary = {
    edgeMaterial: string;
    runningMeter: number;
}

export type MaterialSummary = {
    material: DBMaterialType | undefined;
    numberOfInstances: number;
    edges: Map<string, EdgeSummary>;
    m2: number;
}

export function calculateMaterialsUsed(sheets: SheetData[], materialsDB: DBMaterialType[]): Map<string, MaterialSummary>{
    let usedMaterials = new Set<string>();
    let result = new Map<string, MaterialSummary>();

    for (const sheet of sheets) {
        usedMaterials.add(sheet.materialCode);
    }
    usedMaterials.forEach((code: string) => {
        result.set(code, {
            material: getMaterial(materialsDB, code),
            edges: new Map<string, EdgeSummary>(),
            numberOfInstances: 0,
            m2: 0,
        });
    });


    for (const sheet of sheets) {
        const code: string = sheet.materialCode; // ugh. it actually (sometimes) has label and value
        let res = result.get(code);
        if (res === undefined) {
            console.warn("material code ${code} in not in database");
            continue;
        }
        res.m2 += sheet.width / 1000 * sheet.length / 1000 * sheet.amount;
        res.numberOfInstances += sheet.amount;
        for (const edge of [sheet.edgeUp, sheet.edgeDown]) {
            if (edge === undefined || edge.edgeCode === defaultEdge.value) {
                continue;
            }
            let edgeSummary = res.edges.get(edge.edgeCode);
            if (edgeSummary === undefined) {
                edgeSummary = {
                    edgeMaterial: edge.edgeCode,
                    runningMeter: 0,
                };
                res.edges.set(edge.edgeCode, edgeSummary);
            }
            edgeSummary.runningMeter += sheet.amount * sheet.length / 1000;
        }
        for (const edge of [sheet.edgeLeft, sheet.edgeRight]) {
            if (edge === undefined || edge.edgeCode === defaultEdge.value) {
                continue;
            }
            let edgeSummary = res.edges.get(edge.edgeCode);
            if (edgeSummary === undefined) {
                edgeSummary = {
                    edgeMaterial: edge.edgeCode,
                    runningMeter: 0,
                };
                res.edges.set(edge.edgeCode, edgeSummary);
            }
            edgeSummary.runningMeter += sheet.amount * sheet.width / 1000;
        }
    }
    return result;
}
